<template>
    <div class="p-4 lg:w-full md:w-full">
        <div class="space-y-4">
            <div class="field w-full mb-3">
                <div class="flex items-start w-full">
                    <label class="text-gray-700 font-bold mr-4 w-1/4">
                        File HPS
                    </label>
                    <div class="flex flex-col w-3/4">
                        <!-- Informasi Pagu Anggaran -->
                        <div v-if="!disabled && pagu_anggaran > 0" class="mb-2 p-2 bg-green-50 border border-green-200 rounded text-sm">
                            <div class="flex items-start">
                                <i class="pi pi-info-circle text-green-600 mt-0.5 mr-2"></i>
                                <div>
                                    <span class="font-medium text-green-800">Pagu Anggaran Paket:</span>
                                    <span class="text-green-700 font-bold ml-1">{{ formatCurrency(pagu_anggaran) }}</span>
                                    <div class="text-green-600 mt-1">
                                        <span class="ml-1">Total HPS dari file yang diunggah tidak boleh melebihi nilai ini.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Informasi file yang diperbolehkan -->
                        <div class="mb-2 p-2 bg-blue-50 border border-blue-200 rounded text-sm">
                            <div class="flex items-start">
                                <i class="pi pi-info-circle text-blue-600 mt-0.5 mr-2"></i>
                                <div>
                                    <span class="font-medium text-blue-800">Format file yang diperbolehkan:</span>
                                    <span class="text-blue-700 ml-1">Excel (.xlsx, .xls)</span>
                                    <div class="text-blue-600 mt-1">
                                        <span class="font-medium">Ukuran maksimal:</span>
                                        <span class="ml-1">10 MB</span>
                                    </div>
                                    <div class="text-blue-600 mt-1">
                                        <span class="font-medium">Catatan:</span>
                                        <span class="ml-1">Gunakan template yang disediakan untuk format yang benar</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center justify-end mb-2">
                            <a href="/templates/1742961288_TEMPLATE HPS_update.xlsx" download class="flex items-center text-blue-600 hover:text-blue-800">
                                <i class="pi pi-download mr-1"></i>
                                <span>Download Template</span>
                            </a>
                        </div>
                        <div class="flex items-center bg-gray-100 p-4 rounded-lg w-full">
                            <div v-if="disabled" class="text-center w-full text-gray-500">
                                <i class="pi pi-lock mr-2"></i>
                                <span>Pilih Paket Pengadaan terlebih dahulu untuk mengunggah HPS.</span>
                            </div>
                            <div v-else-if="selectedFileName" class="flex items-center justify-between w-full">
                                <small class="text-gray-700">{{ selectedFileName }}</small>
                                <Button icon="pi pi-trash" @click="removeFile"
                                    class="p-button-text p-button-sm p-button-danger ml-2" />
                            </div>
                            <div v-else>
                                <FileUpload :mode="'basic'" :name="file?.kode_file" :maxFileSize="10000000"
                                    chooseLabel="Pilih File" :auto="true" customUpload accept=".xlsx"
                                    @select="parseFile($event, index)" class="w-full" :disabled="disabled"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="validationErrors.length > 0" class="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
                <div class="flex">
                    <div class="flex-shrink-0">
                        <i class="pi pi-exclamation-circle text-red-500 mr-2"></i>
                    </div>
                    <div>
                        <p class="text-red-700 font-medium">Kesalahan validasi HPS:</p>
                        <ul class="mt-1 list-disc list-inside text-sm text-red-700">
                            <li v-for="(error, index) in validationErrors" :key="index">{{ error }}</li>
                        </ul>
                        
                    </div>
                </div>
            </div>
            
            <!-- Additional debug panel -->
            <div v-if="$page.props?.app?.debug" class="bg-yellow-50 border border-yellow-200 p-2 mb-4 text-xs">
                <strong>Debug Info:</strong><br>
                Validation Errors Count: {{ validationErrors.length }}<br>
                Is Valid: {{ isValid }}<br>
                Local Detail HPS Count: {{ localDetailHps.length }}<br>
                Selected File: {{ selectedFileName }}<br>
                Errors: {{ JSON.stringify(validationErrors) }}
            </div>
            
            <div v-if="localDetailHps.length > 0" class="w-full mt-6">
                <table class="table-auto w-full border-collapse border border-gray-200">
                    <thead>
                        <tr class="bg-gray-100">
                            <th class="border border-gray-200 p-2">No</th>
                            <th class="border border-gray-200 p-2">Nama Barang / Jasa</th>
                            <th class="border border-gray-200 p-2">Merk</th>
                            <th class="border border-gray-200 p-2">Tipe</th>
                            <th class="border border-gray-200 p-2">Spesifikasi</th>
                            <th class="border border-gray-200 p-2">Volume</th>
                            <th class="border border-gray-200 p-2 text-right">Harga Satuan</th>
                            <th class="border border-gray-200 p-2">Satuan</th>
                            <th class="border border-gray-200 p-2 text-right">Jumlah Harga</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(detail, index) in localDetailHps" :key="index">
                            <td class="border border-gray-200 p-2">{{ detail.urutan }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.nama_barang_jasa }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.merk }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.tipe }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.spesifikasi }}</td>
                            <td class="border border-gray-200 p-2">{{ detail.volume }}</td>
                            <td class="border border-gray-200 p-2 text-right">{{ formatCurrency(detail.harga_satuan) }}
                            </td>
                            <td class="border border-gray-200 p-2">{{ detail.satuan }}</td>
                            <td class="border border-gray-200 p-2 text-right">{{ formatCurrency(detail.jumlah_harga) }}
                            </td>
                        </tr>
                        <tr class="bg-gray-100 font-bold">
                            <td colspan="8" class="border border-gray-200 p-2 text-right">Total Jumlah Harga</td>
                            <td class="border border-gray-200 p-2 text-right">{{ formatCurrency(totalJumlahHarga) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import readXlsxFile from "read-excel-file";

import { defineComponent } from 'vue'
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Fieldset,
        Button,
        FileUpload
    },
    props: {
        file_hps: Array,
        detail_hps: {
            type: Array,
            default: () => []
        },
        pagu_anggaran: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedFileName: '',
            kategoriHpsData: [],
            localDetailHps: [],
            validationErrors: [],
            isValid: true,
        };
    },
    computed: {
        totalJumlahHarga() {
            return this.localDetailHps.reduce((total, item) => total + (parseFloat(item.jumlah_harga) || 0), 0);
        }
    },
    
    emits: ['update:file_hps', 'update:detail_hps', 'validation-changed'],
    watch: {
        detail_hps: {
            handler(newVal) {
                this.localDetailHps = [...newVal];
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitCurrentValidationState() {
            this.$emit('validation-changed', this.isValid);
        },
        resetParsedHpsState() {
            this.kategoriHpsData = [];
            this.localDetailHps = [];
            this.$emit('update:detail_hps', []);
        },
        async parseFile(event, index) {
            const file = event.files && event.files.length > 0 ? event.files[0] : null;
            if (file) {
                // Hapus error lama sebelum parsing
                this.validationErrors = [];
                this.isValid = true;
                this.resetParsedHpsState();

                await this.parseExcel(file);

                // Jika parsing gagal (isValid=false), jangan emit file
                if (this.isValid) {
                    this.selectedFileName = file.name;
                    this.$emit('update:file_hps', file);
                } else {
                    // Jangan reset file jika ada error - biarkan user melihat error
                    // Reset hanya selected file name dan emit null
                    this.selectedFileName = '';
                    this.$emit('update:file_hps', null);
                    // JANGAN panggil removeFile() karena akan hapus validationErrors!
                }
            }
        },
        async parseExcel(file) {
            try {
                console.log('Starting to parse Excel file:', file.name);
                const rows = await readXlsxFile(file);
                console.log('Total rows read:', rows.length);
                console.log('First 10 rows:', rows.slice(0, 10));
                
                const detailHps = [];
                let processedRows = 0;
                
                rows.forEach((row, index) => {
                    if (index < 6) return; // Skip rows before row 7 (0-based index)
                    
                    // Skip completely empty rows
                    const hasData = row.some(cell => cell !== null && cell !== undefined && cell !== '');
                    if (!hasData) {
                        console.log(`Skipping empty row ${index + 1}`);
                        return;
                    }
                    
                    console.log(`Processing row ${index + 1}:`, row);
                    processedRows++;
                    
                    const urutan = row[0]; // Column A
                    const nama_barang_jasa = row[1]; // Column B
                    const merk = row[2]; // Column C
                    const tipe = row[3]; // Column D
                    const spesifikasi = row[4]; // Column E
                    const volume = row[5]; // Column F
                    const harga_satuan = row[6]; // Column G
                    const satuan = row[7]; // Column H
                    
                    const volumeNum = parseInt(volume, 10) || 0;
                    const hargaSatuanNum = parseFloat(harga_satuan) || 0.0;
                    const jumlahHarga = volumeNum * hargaSatuanNum;
                    
                    detailHps.push({
                        urutan: urutan || '',
                        nama_barang_jasa: nama_barang_jasa || '',
                        merk: merk || '',
                        tipe: tipe || '',
                        spesifikasi: spesifikasi || '',
                        volume: volumeNum,
                        harga_satuan: hargaSatuanNum,
                        satuan: satuan || '',
                        jumlah_harga: jumlahHarga
                    });
                });

                console.log(`Processed ${processedRows} data rows`);
                console.log('Parsed HPS data:', detailHps);

                // Check if we got any data
                if (detailHps.length === 0) {
                    this.resetParsedHpsState();
                    this.validationErrors = ['Tidak ada data HPS yang ditemukan dalam file. Pastikan data dimulai dari baris ke-7 dan tidak kosong.'];
                    this.isValid = false;
                    this.emitCurrentValidationState();
                    return;
                }

                // Update local data first so table can display
                this.kategoriHpsData = detailHps;
                this.localDetailHps = [...detailHps];
                this.$emit('update:detail_hps', [...detailHps]);

                // Reset validation errors
                this.validationErrors = [];
                this.isValid = true;

                // --- VALIDASI PAGU ANGGARAN ---
                const totalHps = detailHps.reduce((total, item) => total + (item.jumlah_harga || 0), 0);
                console.log('Total HPS calculated:', totalHps);
                console.log('Pagu Anggaran:', this.pagu_anggaran);

                if (this.pagu_anggaran > 0 && totalHps > this.pagu_anggaran) {
                    this.validationErrors.push(
                        `Total HPS (${this.formatCurrency(totalHps)}) melebihi Pagu Anggaran (${this.formatCurrency(this.pagu_anggaran)}).`
                    );
                    this.isValid = false;
                }
                // --- AKHIR VALIDASI PAGU ANGGARAN ---
                
                // Validate the HPS data (will add more errors if any)
                this.validateHpsData();

            } catch (error) {
                console.error('Error reading excel file:', error);
                this.resetParsedHpsState();
                this.validationErrors = [
                    'Terjadi kesalahan saat membaca file Excel. Silakan periksa formatnya.',
                    `Detail error: ${error.message}`
                ];
                this.isValid = false;
                this.emitCurrentValidationState();
            }
        },
        removeFile() {
            this.selectedFileName = '';
            this.kategoriHpsData = [];
            this.localDetailHps = [];
            this.validationErrors = [];
            this.isValid = true;
            this.$emit('update:file_hps', null);
            this.$emit('update:detail_hps', []);
            this.emitCurrentValidationState();
        },
        formatCurrency(value) {
            if (typeof value !== 'number') {
                return 'Rp 0,00';
            }
            return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value);
        },
        
        validateHpsData() {
            // Don't reset validation errors - preserve existing ones from pagu anggaran check
            // this.validationErrors = []; // Remove this line
            
            console.log('Starting validateHpsData');
            console.log('Current validation errors:', this.validationErrors);
            console.log('localDetailHps:', this.localDetailHps);
            
            // Check if HPS data exists
            if (!this.localDetailHps || this.localDetailHps.length === 0) {
                console.log('No HPS data found');
                this.validationErrors.push('Data HPS tidak ditemukan. Silakan unggah file HPS yang valid.');
                this.isValid = false;
                this.emitCurrentValidationState();
                return;
            }
            
            let errorCount = 0;
            
            // Check for zero or null values
            this.localDetailHps.forEach((item, index) => {
                const itemNumber = index + 1;
                console.log(`Validating item #${itemNumber}:`, item);
                
                if (!item.nama_barang_jasa) {
                    this.validationErrors.push(`Item #${itemNumber}: Nama Barang/Jasa kosong`);
                    errorCount++;
                }
                
                if (!item.merk || item.merk.toString().trim() === '') {
                    this.validationErrors.push(`Item #${itemNumber}: Merk tidak boleh kosong`);
                    errorCount++;
                }
                
                if (!item.tipe || item.tipe.toString().trim() === '') {
                    this.validationErrors.push(`Item #${itemNumber}: Tipe tidak boleh kosong`);
                    errorCount++;
                }
                
                if (item.volume === 0 || item.volume === null) {
                    this.validationErrors.push(`Item #${itemNumber}: Volume tidak boleh nol atau kosong`);
                    errorCount++;
                }
                
                if (item.harga_satuan === 0 || item.harga_satuan === null) {
                    this.validationErrors.push(`Item #${itemNumber}: Harga Satuan tidak boleh nol atau kosong`);
                    errorCount++;
                }
                
                if (!item.satuan || item.satuan.toString().trim() === '') {
                    this.validationErrors.push(`Item #${itemNumber}: Satuan tidak boleh kosong`);
                    errorCount++;
                }
                
                if (item.jumlah_harga === 0 || item.jumlah_harga === null) {
                    this.validationErrors.push(`Item #${itemNumber}: Jumlah Harga tidak boleh nol atau kosong`);
                    errorCount++;
                }
            });
            
            console.log(`Found ${errorCount} validation errors in items`);
            console.log('Final validation errors:', this.validationErrors);
            
            // Update validation status based on all errors
            this.isValid = this.validationErrors.length === 0;
            console.log('isValid:', this.isValid);
            this.emitCurrentValidationState();
        }
    }
});
</script>
